import { render } from "./BlockItem.vue?vue&type=template&id=3553b0a2&ts=true"
import script from "./BlockItem.vue?vue&type=script&lang=ts"
export * from "./BlockItem.vue?vue&type=script&lang=ts"

import "./BlockItem.vue?vue&type=style&index=0&id=3553b0a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__